"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.palette2 = void 0;

var _constants = require("../constants");

/**
 * Theme's main colors
 */
const palette = {
  primaryColor: '#3C91E6',
  secondaryColor: '#dfebf0',
  textColor: '#393e44',
  errorColor: '#e64646',
  secondaryErrorColor: '#ffe3dc',
  successColor: '#018a01',
  secondarySuccessColor: '#aff9af',
  disabledColor: '#dbdbdb',
  backgroundDisabledColor: '#EBEDEF',
  secondaryTextColor: '#ffffff',
  hoverMenuPrimaryColor: '#e6f4fc',
  backgroundActiveColor: '#e6f4fc',
  menuPrimaryColor: '#ffffff',
  tooltipColor: '#35404b',
  activePaginationColor: '#35404b',
  toggleSwitchNotActive: '#c2c5c9',
  modalBgColor: '#F6F7F8'
}; // Обновленная палитра

const palette2 = {
  primary: '#1973E8',
  primaryHover: '#1E6AD0',
  primary30: '#BAD5F8',
  primary10: '#F0F6FD',
  primary2: '#F9FBFE',
  primary20: '#E7F1FF',
  white: '#FFFFFF',
  black: '#393F48',
  gray: '#7E8A9A',
  gray10: '#F6F7F8',
  buttons: '#ACB3BE',
  disabled: '#DDE0E5',
  green: '#129D59',
  purple: '#9037DB',
  yellow: '#F4B400',
  yellow10: '#FBE8B3',
  green10: '#B8DFCB',
  purple10: '#B8C0DF',
  red: '#DB4437',
  red10: '#F1A7A7',
  red20: '#FFE5E5',
  red30: '#F84545',
  borderColor: '#eaecef',
  bgActiveColor: '#E8F1FD'
};
/**
 * Animation logic
 */

exports.palette2 = palette2;
const easingArr = {
  easeInOut: 'cubic-bezier(.23,1,.32,1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * Text-align
 */

const textAlign = {
  start: 'start',
  end: 'end',
  center: 'center',
  justify: 'justify'
};
/**
 * Transition wrapper
 */

function transition(props, duration = 450, delay = 0, easing = 'easeInOut') {
  const trArr = [];
  const easingVal = easingArr[easing];
  props.forEach(prop => {
    const tr = `${prop} ${duration}ms ${easingVal} ${delay}ms`;
    trArr.push(tr);
  });
  return trArr.join(', ');
}
/**
 * Transition wrapper for difficult animation
 */


function transitionArr(props) {
  const trArr = [];
  props.forEach(prop => {
    const field = prop[0] || 'all';
    const duration = prop[1] || 300;
    const delay = prop[2] || 0;
    const easingVal = easingArr[prop[3]] || easingArr.easeInOut;
    const tr = `${field} ${duration}ms ${easingVal} ${delay}ms`;
    trArr.push(tr);
  });
  return trArr.join(', ');
}
/**
 * boxShadow wrapper
 */


function boxShadow(level = 2) {
  const shadowLevels = {
    0: 'none',
    1: '0 2px 4px 0 rgba(57, 62, 68, 0.2)',
    2: '0 4px 7px 0 rgba(57, 62, 68, 0.2)',
    3: '0 8px 16px 0 rgba(57, 62, 68, 0.2)',
    4: '0 16px 24px 0 rgba(57, 62, 68, 0.2)',
    5: '0 24px 32px 0 rgba(57, 62, 68, 0.2)'
  };
  return shadowLevels[level];
}
/**
 * Base font
 */


const font = {
  family: {
    main: '"Open Sans", sans-serif;'
  },
  size: {
    small: 10,
    caption: 12,
    body: 14,
    subheader: 18,
    title: 24
  },
  weight: {
    regular: 400,
    semibold: 600
  },
  lineHeight: '1.36em' // Common value for this font in different sizes

};
/**
 * Main theme's settings
 */

const theme = {
  transition,
  transitionArr,
  boxShadow,
  disabledOpacity: 0.5,
  disabledCursor: 'not-allowed',
  icon: {
    color: palette2.buttons,
    micro: 8,
    small: 12,
    medium: 16,
    large: 24,
    xlarge: 32,
    xxlarge: 60
  },
  // Unified space sizes between components
  spaceSize: {
    [_constants.SPACE_SIZE.none]: null,
    [_constants.SPACE_SIZE.micro]: 2,
    [_constants.SPACE_SIZE.xxsmall]: 4,
    [_constants.SPACE_SIZE.xsmall]: 8,
    [_constants.SPACE_SIZE.small]: 12,
    [_constants.SPACE_SIZE.medium]: 16,
    [_constants.SPACE_SIZE.large]: 20,
    [_constants.SPACE_SIZE.xlarge]: 24,
    [_constants.SPACE_SIZE.xxlarge]: 40
  },
  // Unified border radiuses for components
  borderRadius: {
    [_constants.BORDER_RADIUS.none]: 0,
    [_constants.BORDER_RADIUS.small]: 2,
    [_constants.BORDER_RADIUS.medium]: 4,
    [_constants.BORDER_RADIUS.large]: 8,
    [_constants.BORDER_RADIUS.xlarge]: 10,
    [_constants.BORDER_RADIUS.xxlarge]: 12
  },
  // Unified colors available to set in component
  palette: {
    [_constants.COLOR.primary]: palette2.primary,
    [_constants.COLOR.secondary]: palette2.gray10,
    [_constants.COLOR.tertiary]: palette2.primary10,
    [_constants.COLOR.accent]: palette2.borderColor,
    [_constants.COLOR.white]: palette2.white,
    [_constants.COLOR.black]: palette2.black,
    [_constants.COLOR.gray]: palette2.gray,
    [_constants.COLOR.red]: palette2.red30
  },
  // Full set of named colors used in components
  fullPalette: palette2,
  borderWidth: {
    [_constants.BORDER_WIDTH.none]: 0,
    [_constants.BORDER_WIDTH.thin]: 0.5,
    [_constants.BORDER_WIDTH.medium]: 1,
    [_constants.BORDER_WIDTH.thick]: 3
  },
  autocomplete: {
    borderWidthMedium: 1,
    textColor: palette2.black,
    colorLabel: palette2.gray,
    placeholder: palette2.gray,
    boxShadow: boxShadow(),
    fontSizeLabel: font.size.caption,
    fontSizeHelper: font.size.caption,
    fontSizeMedium: font.size.body,
    fontSizeSmall: font.size.body,
    searchBackgroundColor: palette2.white,
    rightTextColor: palette2.primary,
    item: {
      paddingLarge: '0px 16px 0 16px',
      paddingMedium: '0px 24px 0 24px',
      background: palette2.white,
      hover: {
        background: palette2.primary10
      },
      labelColor: palette2.black,
      borderColor: palette2.disabled
    },
    bordered: {
      borderColor: palette2.disabled,
      borderRadius: 4
    },
    error: {
      borderColor: palette2.red,
      colorLabel: palette2.red
    },
    active: {
      borderColor: palette2.primary,
      colorLabel: palette2.primary
    }
  },
  avatar: {
    background: palette2.primary30,
    color: palette2.primary,
    size: {
      small: 24,
      medium: 32,
      large: 40,
      xlarge: 56,
      xxlarge: 100
    },
    fontSize: {
      small: font.size.small,
      medium: font.size.body,
      large: font.size.body,
      xlarge: font.size.subheader,
      xxlarge: font.size.subheader
    },
    fontWeight: {
      normal: font.weight.regular,
      semibold: font.weight.semibold
    }
  },
  buttonBackgroundColor: {
    default: palette2.primary,
    text: 'transparent',
    secondary: palette2.white,
    tertiary: palette2.gray10,
    quaternary: palette2.primary20,
    error: palette2.red20
  },
  button: {
    borderRadius: 4,
    border: 1,
    boxShadow: boxShadow(0),
    disabledTextColor: palette2.white,
    [_constants.BUTTON_TYPE.default]: {
      normal: {
        backgroundColor: palette2.primary,
        color: palette2.white,
        borderColor: palette2.primary
      },
      hover: {
        backgroundColor: palette2.primaryHover,
        color: palette2.white,
        borderColor: palette2.primaryHover
      },
      disabled: {
        cursor: 'default',
        backgroundColor: palette2.disabled,
        borderColor: palette2.disabled,
        color: palette2.white
      }
    },
    [_constants.BUTTON_TYPE.secondary]: {
      normal: {
        backgroundColor: palette2.white,
        color: palette2.primary,
        borderColor: palette2.primary
      },
      hover: {
        backgroundColor: palette2.primary10,
        color: palette2.primary,
        borderColor: palette2.primary
      },
      disabled: {
        cursor: 'default',
        backgroundColor: palette2.disabled,
        borderColor: palette2.disabled,
        color: palette2.white
      }
    },
    [_constants.BUTTON_TYPE.tertiary]: {
      normal: {
        backgroundColor: palette2.gray10,
        color: palette2.black,
        borderColor: palette2.gray10,
        iconColor: palette2.buttons
      },
      hover: {
        backgroundColor: palette2.primary20,
        color: palette2.primary,
        borderColor: palette2.primary20,
        iconColor: palette2.primary
      },
      disabled: {
        cursor: 'default',
        backgroundColor: palette2.disabled,
        borderColor: palette2.disabled,
        color: palette2.white,
        iconColor: palette2.white
      }
    },
    [_constants.BUTTON_TYPE.quaternary]: {
      normal: {
        backgroundColor: palette2.primary20,
        color: palette2.primary,
        borderColor: palette2.primary20
      },
      hover: {
        backgroundColor: palette2.primary20,
        color: palette2.primary,
        borderColor: palette2.primary
      },
      disabled: {
        cursor: 'default',
        backgroundColor: palette2.disabled,
        borderColor: palette2.disabled,
        color: palette2.white
      }
    },
    [_constants.BUTTON_TYPE.quinary]: {
      normal: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: palette2.black,
        iconColor: palette2.buttons
      },
      hover: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: palette2.primary,
        iconColor: palette2.primary
      },
      disabled: {
        cursor: 'default',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: palette2.disabled,
        iconColor: palette2.disabled
      }
    },
    [_constants.BUTTON_TYPE.error]: {
      normal: {
        backgroundColor: palette2.red20,
        color: palette2.red30,
        borderColor: palette2.red20
      },
      hover: {
        backgroundColor: palette2.red20,
        color: palette2.red30,
        borderColor: palette2.red30
      },
      disabled: {
        cursor: 'default',
        backgroundColor: palette2.disabled,
        borderColor: palette2.disabled,
        color: palette2.white
      }
    },
    [_constants.BUTTON_TYPE.text]: {
      normal: {
        backgroundColor: 'transparent',
        color: palette2.primary,
        borderColor: 'transparent'
      },
      hover: {
        backgroundColor: palette2.primary10,
        color: palette2.primary,
        borderColor: palette2.primary10
      },
      disabled: {
        cursor: 'default',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: palette2.disabled
      }
    }
  },
  chip: {
    background: palette2.primary2,
    borderColor: palette2.disabled,
    closeIconColor: palette2.buttons,
    maxLengthText: 120,
    micro: {
      height: 16
    },
    small: {
      height: 24,
      rectangular: {
        borderRadius: 3
      }
    },
    medium: {
      height: 32,
      rectangular: {
        borderRadius: 4
      }
    },
    large: {
      height: 40,
      rectangular: {
        borderRadius: 6
      }
    }
  },
  label: {
    fontFamily: font.family.main,
    fontSize: {
      [_constants.LABEL_FONT_SIZE.xsmall]: font.size.small,
      [_constants.LABEL_FONT_SIZE.small]: font.size.caption,
      [_constants.LABEL_FONT_SIZE.medium]: font.size.body,
      [_constants.LABEL_FONT_SIZE.large]: font.size.subheader,
      [_constants.LABEL_FONT_SIZE.xlarge]: font.size.title
    },
    fontWeight: {
      [_constants.LABEL_FONT_WEIGHT.normal]: font.weight.regular,
      [_constants.LABEL_FONT_WEIGHT.semibold]: font.weight.semibold
    },
    textAlign: {
      [_constants.LABEL_TEXT_ALIGN.start]: textAlign.start,
      [_constants.LABEL_TEXT_ALIGN.end]: textAlign.end,
      [_constants.LABEL_TEXT_ALIGN.center]: textAlign.center,
      [_constants.LABEL_TEXT_ALIGN.justify]: textAlign.justify
    },
    lineHeight: font.lineHeight,
    errorColor: palette2.red
  },
  divider: {
    color: palette2.disabled
  },
  menu: {
    boxShadow: boxShadow(),
    bgColor: palette2.white,
    item: {
      bgColor: palette2.white,
      hover: {
        bgColor: palette2.primary10
      },
      active: {
        bgColor: palette2.primary10,
        icon: palette2.primary
      },
      label: {
        fontSize: font.size.body,
        color: palette2.black
      },
      children: {
        fontSize: font.size.caption,
        color: palette2.gray
      }
    }
  },
  modal: {
    small: 480,
    medium: 560,
    large: 640,
    xlarge: 960,
    borderRadius: 10,
    bgColor: palette2.gray10,
    titleBgColor: palette2.white,
    boxShadow: boxShadow(),
    borderColor: palette2.borderColor,
    padding: 24,
    errorColor: palette2.red,
    contentPadding: 20,
    buttonsPadding: '0px 20px 20px',
    headerHeight: 56,
    headerPadding: 16,
    spacingButton: 8,
    titleColor: palette2.black,
    cancelBtnColor: palette2.primary,
    cancelBtnHoverColor: '#1954E8'
  },
  notify: {
    width: 400,
    padding: 12,
    borderWidth: 1,
    boxShadow: boxShadow(),
    textColor: palette2.black,
    bgColor: palette2.white,
    normalBorderColor: palette2.disabled,
    normalTitleBgColor: palette2.primary2,
    normalIconColor: palette2.buttons,
    successBorderColor: palette2.green,
    successTitleBgColor: palette2.green10,
    successIconColor: palette2.green,
    errorBorderColor: palette2.red,
    errorTitleBgColor: palette2.red10,
    errorIconColor: palette2.red
  },
  progressBar: {
    backgroundColor: palette2.disabled,
    color: palette2.primary,
    strokeWidth: 4
  },
  pagination: {
    labelColor: palette2.black,
    itemColor: palette2.black,
    itemHoverColor: palette2.primary,
    itemHoverBorderColor: palette2.primary20,
    itemHoverBgColor: palette2.primary20,
    itemActiveColor: palette2.white,
    itemActiveBorderColor: palette2.primary,
    itemActiveBgColor: palette2.primary,
    itemBorderRadius: 2,
    fontSize: font.size.body,
    fontWeightSemibold: font.weight.semibold,
    iconColor: palette2.black,
    iconColorDisabled: palette2.buttons,
    iconHoverColor: palette2.primary
  },
  tab: {
    borderBottomContainerColor: palette2.disabled,
    color: palette2.gray,
    activeColor: palette2.primary,
    errorColor: palette2.red,
    disabledColor: palette2.disabled,
    smallHeightUnderline: 1,
    mediumHeightUnderline: 2
  },
  textField: {
    borderColor: palette2.disabled,
    fontSizeLabel: font.size.body,
    colorLabel: palette2.gray,
    fontSizeHelper: font.size.caption,
    colorHelper: palette2.gray,
    fontSizeSmall: font.size.body,
    fontSizeMedium: font.size.body,
    placeholder: palette2.gray,
    closeIconColor: palette2.buttons,
    active: {
      fontSizeLabel: font.size.caption,
      colorLabel: palette2.primary,
      borderColor: palette2.primary,
      fontSizeHelper: font.size.caption,
      colorHelper: palette2.black,
      size: palette2.body,
      color: palette2.black,
      closeIconColor: palette2.buttons
    },
    selected: {
      fontSizeLabel: font.size.caption,
      colorLabel: palette2.gray,
      borderColor: palette2.buttons,
      fontSizeHelper: font.size.caption,
      colorHelper: palette2.black,
      size: palette2.body,
      color: palette2.black,
      closeIconColor: palette2.buttons
    },
    error: {
      fontSizeLabel: font.size.caption,
      colorLabel: palette2.gray,
      borderColor: palette2.red,
      fontSizeHelper: font.size.caption,
      colorHelper: palette2.red,
      size: palette2.body,
      color: palette2.black,
      closeIconColor: palette2.red
    },
    bordered: {
      borderRadiusSmall: 3,
      borderRadiusMedium: 4,
      borderRadiusLarge: 4
    }
  },
  toggleSwitch: {
    color: palette2.buttons,
    activeColor: palette2.primary,
    borderColor: palette2.buttons,
    borderActiveColor: palette2.primary,
    disabledColor: palette2.disabled,
    errorColor: palette2.red,
    small: {
      width: 24,
      height: 12,
      border: 1
    },
    medium: {
      width: 28,
      height: 16,
      border: 2
    },
    large: {
      width: 34,
      height: 20,
      border: 2
    }
  },
  tooltip: {
    background: palette2.black,
    textColor: palette2.white,
    textSizeMedium: font.size.caption,
    textSizeLarge: font.size.body,
    borderRadius: 4,
    borderRadiusArrow: 2
  },
  checkbox: {
    textColor: palette2.gray,
    textActiveColor: palette2.black,
    textDisabledColor: palette2.disabled,
    iconColor: palette2.buttons,
    iconActiveColor: palette2.primary,
    iconDisabledColor: palette2.disabled
  },
  list: {
    item: {
      active: {
        color: palette2.primary,
        background: palette2.bgActiveColor
      },
      hover: {
        color: palette2.primary
      }
    }
  },
  radio: {
    background: palette2.primary,
    color: palette2.black,
    paddingHorizontal: 20,
    paddingLabel: 8,
    textColor: palette2.gray,
    textActiveColor: palette2.black,
    textDisabledColor: palette2.disabled,
    iconColor: palette2.buttons,
    iconActiveColor: palette2.primary,
    iconDisabledColor: palette2.disabled
  },
  sideBar: {
    item: {
      iconActiveColor: palette2.primary,
      textColor: palette2.gray,
      textActiveColor: palette2.black,
      bgColor: palette2.white,
      bgHoverColor: palette2.primary10,
      bgActiveColor: palette2.primary30,
      borderRadius: 4
    }
  },
  badge: {
    backgroundColor: palette2.primary,
    color: palette2.white,
    borderColor: palette2.white
  },
  upload: {
    backgroundColor: palette2.primary2,
    browseLinkColor: palette2.primary,
    iconUploadColor: palette2.black,
    iconCloseHoverFill: palette2.primary,
    borderRadius: 3,
    doneColor: palette.successColor,
    errorColor: palette2.red,
    borderColor: palette2.disabled,
    borderItemColor: '#cccccc',
    active: {
      backgroundColor: palette2.bgActiveColor,
      borderColor: palette2.primary
    }
  },
  code: {
    backgroundColor: palette2.primary10,
    borderRadius: 3,
    btnColor: palette2.primary,
    textColor: palette2.black,
    textSize: font.size.body
  },
  sendForm: {
    borderRadius: 3,
    borderColor: '#DEE3E8',
    iconFill: '#C0C9D1',
    active: {
      borderColor: palette2.primary
    },
    done: {
      backgroundColor: '#F3FFF1',
      iconFill: '#34C21B',
      borderColor: '#34C21B'
    },
    reject: {
      backgroundColor: '#FFF5F5',
      iconFill: '#E42F1D',
      borderColor: '#E42F1D'
    },
    sign: {
      backgroundColor: palette2.primary10,
      iconFill: palette2.primary,
      borderColor: palette2.primary
    },
    quote: {
      borderRadius: 4,
      iconFill: palette2.primary
    }
  },
  calendar: {
    error: palette2.red,
    mainBgColor: palette2.white,
    periodColor: palette2.black,
    periodIconColor: palette2.black,
    periodIconHoverColor: palette2.primary,
    periodIconDisabledColor: palette2.disabled,
    dayColor: palette2.black,
    dayHoverColor: palette2.primary,
    dayHoverBorderColor: palette2.primary,
    dayHoverBgColor: palette2.primary10,
    dayActiveColor: palette2.primary,
    dayInRange: '#F0F6FD',
    dayTodayBgColor: palette2.red20,
    dayDisabledColor: palette2.disabled,
    dayOtherMonthColor: palette2.buttons,
    daySelectedColor: palette2.white,
    daySelectedBorderColor: palette2.primary,
    daySelectedBgColor: palette2.primary,
    boxShadow: boxShadow(),
    borderRadius: 3,
    timeBorderColor: palette2.buttons,
    timeBorderActiveColor: palette2.primary,
    timezoneIconColor: palette2.buttons,
    headerBgColor: palette2.gray10,
    borderColor: '#DDE0E5',
    textColor: palette2.black
  },
  table: {
    rowActiveBgColor: palette2.primary,
    rowHoverBgColor: palette2.primary10,
    bgColor: palette2.white,
    cellFontSize: font.size.body,
    cellHeaderColor: palette2.gray,
    cellHeaderBgColor: palette2.white,
    cellColor: palette2.black,
    cellActiveColor: palette2.white,
    arrowColor: palette2.buttons,
    arrowActiveColor: palette2.white
  },
  banner: {
    textColor: palette2.black,
    linkColor: palette2.primary,
    linkHoverColor: palette2.primaryHover,
    mainBgColor: palette2.primary10,
    errorBgColor: palette2.red10,
    mainLineBgColor: palette2.primary,
    errorLineBgColor: palette2.red,
    borderRadius: 2,
    fontSize: {
      small: font.size.caption,
      medium: font.size.body
    },
    fontWeight: {
      semibold: font.weight.semibold
    }
  }
};

var _default = Object.assign({}, theme, palette);

exports.default = _default;